import React, { Component } from "react";
import { CallTagTheme } from "modules/theme";
import PropTypes from "prop-types";
import { globalStateSelector } from "store/selector";
import { messageAction, globalAction, callAction } from "store/action";
import { connect } from "react-redux";
import { Alert } from "modules/common/utils";
import MessageHelper from "../../../store/helper/message.helper";
import moment from "moment";
global.__btnTimer = "";
global.__disposeTimer = "";
export class CallTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {},
      tags: [],
      comment: "",
    };
    this.startTimer = this.startTimer.bind(this);
  }
  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage("message-processor", message);
  }
  tagProcessMessage(message) {
    const { tagProcess } = this.props;
    tagProcess("message-processor", message);
  }
  startTimer(state) {
    const { callInfo, dynamicUpdate } = this.props;
    dynamicUpdate({ key: "callHandlingState", value: state });
    clearTimeout(global.__btnTimer);
    global.__btnTimer = setTimeout(() => {
      dynamicUpdate({ key: "callHandlingState", value: "" });
    }, 10000);
  }
  tagProcessor(tagList, items) {
    // if( selected )
    let list = [];
    if (items && items.length) {
      for (const disposeId of items) {
        if (disposeId) {
          let hasList = false;
          for (const tag of tagList) {
            if (tag._id == disposeId) {
              hasList = true;
              list.push({
                label: tag.name,
                value: tag._id,
                // ...el
              });
              if (tag.childs && tag.childs.length) {
                tagList = tag.childs;
              } else {
                tagList = [];
              }
              break;
            }
          }
          if (!hasList) {
            break;
          }
        }
      }
    } else {
      if (!tagList || tagList.length == 0) {
        tagList = [
          {
            name: "No Tags Found",
            _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
          },
        ];
      }
    }
    tagList.forEach((el) => {
      list.push({
        label: el.name,
        value: el._id,
        // ...el
      });
    });
    return list;
  }
  checkDispose(items, tagList) {
    let list = [];
    let finalTag = {};
    let levelWise = {};
    let currentLevel = 0;
    items = items || [];
    tagList = tagList || [];
    for (const dispose of items) {
      if (dispose.value) {
        if (dispose.value == "d62d0ebc-607d-479f-ac14-fe314875258c") {
          finalTag = dispose;
          levelWise[`level${currentLevel}`] = {
            name: "No Tags Found",
            _id: dispose.value,
          };
          finalTag["finalLevel"] = currentLevel;
          finalTag["label"] = "No Tags Found";
          finalTag["value"] = dispose.value;
          finalTag["name"] = "No Tags Found";
          finalTag["_id"] = dispose.value;
          list.push(dispose.value);
          break;
        } else {
          let hasList = false;
          for (const tag of tagList) {
            if (tag._id == dispose.value) {
              hasList = true;
              if (tag.childs && tag.childs.length) {
                tagList = tag.childs;
                if (tag._id) {
                  levelWise[`level${currentLevel}`] = {
                    name: tag.name || "",
                    _id: tag._id,
                  };
                }
                currentLevel++;
              } else {
                finalTag = tag;
                levelWise[`level${currentLevel}`] = {
                  name: tag.name,
                  _id: tag._id,
                };
                delete finalTag.childs;
                delete finalTag.create_at;
                delete finalTag.createBy;
                finalTag["finalLevel"] = currentLevel;
                finalTag["label"] = tag.name;
                finalTag["value"] = tag._id;
              }
              break;
            }
          }
          if (!hasList) {
            break;
          }
        }

        list.push(dispose.value);
      }
    }
    if (finalTag && finalTag._id) {
      finalTag = { ...finalTag, ...levelWise };
    }
    return { list, finalTag };
    // try {
    //   if ( isNaN(dispose.value) ){
    //     dispose.value2 = dispose.value;
    //     dispose.value = "333";
    //   } else {
    //     dispose.value2 = "d62d0ebc-607d-479f-ac14-fe314875258c";
    //   }
    // } catch (error) {
    // }
  }

  handleAutoDisposeSnooze() {
    try {
      if (!Number.isNaN(global.__currentTeamDisposeTime)) {
        global.__disposeTime = global.__currentTeamDisposeTime;
      }
    } catch (err) {
      console.log("Unable to snooze");
    }
  }

  render() {
    let _this = this;
    let {
      configProcessor,
      customerNumber,
      customerName,
      callTeam,
      callBackDate,
      dncType,
      currentUser,
      tagsList,
      callInfo,
      isBack,
      dynamicUpdate,
      isPreviewDial,
      isCallbackDial,
      callComment,
      callTagList,
      callTagFinalTag,
      custInfo,
      callProcess,
      callState,
      cbNotify,
      userState,
      teamList,
      disposeTimer,
    } = this.props;
    // check customer info
    custInfo = custInfo || {};
    callBackDate = callBackDate || moment();
    tagsList =
      tagsList && tagsList.length
        ? tagsList
        : [
            {
              name: "No Tags Found",
              _id: "d62d0ebc-607d-479f-ac14-fe314875258c",
            },
          ];
    return (
      <CallTagTheme
        title={"Tag"}
        onChangeSelect={(items) => {
          if (items && items.length) {
            let { list, finalTag } = this.checkDispose(items, tagsList);
            this.setState({ selected: list, tags: list });
            dynamicUpdate({ key: "callTagList", value: list });
            dynamicUpdate({ key: "callTagFinalTag", value: finalTag });
          } else {
            this.setState({ selected: [], tags: [] });
            dynamicUpdate({ key: "callTagList", value: [] });
            dynamicUpdate({ key: "callTagFinalTag", value: {} });
          }
        }}
        tagValue={callTagList}
        callTagFinalTag={callTagFinalTag}
        comment={callComment}
        // optionsTag={this.generateParamsFromArray()}
        optionsTag={this.tagProcessor(tagsList, callTagList)}
        onCommentChange={(e) => {
          this.setState({ comment: e.target.value });
          dynamicUpdate({ key: "callComment", value: e.target.value });
        }}
        // callback data
        callBackDate={callBackDate}
        onDateChange={(date) => {
          date = date || "";
          dynamicUpdate({ key: "callBackDate", value: date });
        }}
        // dnc data
        dncType={dncType}
        onDncChange={(type) => {
          type = type || "";
          dynamicUpdate({ key: "dncType", value: type });
        }}
        isBack={isBack}
        callState={callState}
        onDoneClick={(state = "") => {
          this.props.clearAgentAssist();
          this.props.clearTranscription();
          this.props.clearSummary();
          this.props.clearChecklist();
          if (isBack) {
            dynamicUpdate({ key: "callTab", value: "call" });
          } else {
            this.startTimer("doneLoading");
            if (
              !callTagList ||
              callTagList.length == 0 ||
              !callTagFinalTag ||
              !callTagFinalTag._id
            ) {
              if (!callTagList || callTagList.length > 0) {
                Alert.error(`Please select child disposition and press done`);
              } else {
                Alert.error(`Please select disposition and press done`);
              }
              clearTimeout(global.__btnTimer);
              dynamicUpdate({ key: "callHandlingState", value: "" });
              return;
            }

            // call back set
            if (callTagFinalTag.isCallback) {
              if (!callBackDate) {
                Alert.error(`Please select call schedule date and time`);
                clearTimeout(global.__btnTimer);
                dynamicUpdate({ key: "callHandlingState", value: "" });
                return;
              } else {
                try {
                  let cbDate = callBackDate.format("YYYY-MM-DD HH:mm:00");
                  let data = {
                    task: "a",
                    customerNo: customerNumber,
                    customerName: customerName,
                    assignTo: "user",
                    assignToId:
                      currentUser && currentUser.userId
                        ? currentUser.userId
                        : "",
                    dateTime: cbDate,
                    subjectCallDetail:
                      `Your Callback Has been schedule at ` +
                      callBackDate.format("LT"),
                    note: callComment,
                    detail: {
                      team: callTeam || {},
                      custInfo: custInfo,
                    },
                  };
                  configProcessor("callback:scedule", data);
                } catch (error) {
                  console.log("Callback set error", error);
                }
              }
            }
            // dnc set
            if (callTagFinalTag.isDnc) {
              dncType = dncType || "team";
              let data = {
                phone_number: customerNumber,
                customerName: customerName,
                type: dncType,
                team:
                  dncType == "team"
                    ? callTeam && callTeam.id
                      ? callTeam.id
                      : ""
                    : "",
                tags: callTagFinalTag,
                note: callComment,
                campaign: dncType == "campaign" ? "" : "",
              };
              configProcessor("dnc:add", data);
            }

            let extraInfo = {
              selected: callTagFinalTag,
              tags: [callTagFinalTag],
              finalTag: [callTagFinalTag],
              customerInfo: custInfo.info || {},
              comment: callComment,
              isCallback: callTagFinalTag.isCallback,
              isDnc: callTagFinalTag.isDnc,
              callBackDate: callBackDate,
              dncType: dncType,
            };

            // check csat
            let csat = false;
            let teamId = callTeam && callTeam.id ? callTeam.id : "";
            try {
              let teams = teamList.filter((el) => {
                return el._id == teamId;
              });
              if (teams && teams[0] && teams[0].csat && teams[0].csatFlowId) {
                if (teams[0].csat == true || teams[0].csat == "TRUE") {
                  csat = true;
                }
              }
            } catch (error) {}

            if (callInfo.isTransferInitialed || csat) {
              callProcess("AddTAGToCall", {
                sessionId: callInfo.sessionId,
                callId: callInfo.agentId,
                callId2: callInfo.custId,
                isCSAT: csat,
                ...extraInfo,
              });
              extraInfo = {};
            }
            let nextState =
              cbNotify || isCallbackDial
                ? "callback"
                : isPreviewDial
                ? "preview"
                : "online";
            let message = {
              type: "stateHandler",
              state: state || nextState,
              sessionId: callInfo.sessionId,
              mSessionID: callInfo.sessionId,
              initdate: callInfo.initdate,
              addTag: true,
              subState: "",
              stateInfo: "",
              ...extraInfo,
            };
            _this.tagProcessMessage(message);
            try {
              MessageHelper.iframeEventPush(userState,"softphoneCallEnded");
              // let callInfo = userState.extraData || userState.callInfo || {};
              // let agentInfo = {};
              // if (callInfo.call1 && callInfo.call1.userId == userState.UserId) {
              //   agentInfo = callInfo.call1;
              // } else if (
              //   callInfo.call2 &&
              //   callInfo.call2.userId == userState.UserId
              // ) {
              //   agentInfo = callInfo.call2;
              // } else if (callInfo.calls && callInfo.calls.length) {
              //   for (let data of callInfo.calls) {
              //     if (data.userId == userState.UserId) {
              //       agentInfo = data;
              //       break;
              //     }
              //   }
              // }
              // let customerInfo = {};
              // if (callInfo.call1 && callInfo.call1.isCustomer) {
              //   customerInfo = callInfo.call1;
              // } else if (callInfo.call2 && callInfo.call2.isCustomer) {
              //   customerInfo = callInfo.call2;
              // } else if (callInfo.calls) {
              //   for (let data of callInfo.calls) {
              //     if (data.isCustomer) {
              //       customerInfo = data;
              //       break;
              //     }
              //   }
              // }
              // let userInfo = {
              //   userFullName: callInfo.user ? callInfo.user.name : "",
              //   agentExtension: agentInfo.type,
              // };
              // let disposeProcessData = {
              //   disposeName: callTagList.label || "",
              //   // disposecomment:callComment || '',
              //   // callbackdate:callBackDate || '',
              // };
              // let eventInfo = {
              //   type: "disposeProcess",
              // };
              // window.parent.postMessage(
              //   {
              //     disposeProcessData: disposeProcessData,
              //     callInfo: callInfo,
              //     customerInfo: customerInfo,
              //     userInfo: userInfo,
              //     agentInfo: agentInfo,
              //     eventInfo: eventInfo,
              //   },
              //   "*"
              // );
            } catch (e) {}
            dynamicUpdate({ key: "callTagList", value: [] });
            dynamicUpdate({ key: "callTagFinalTag", value: {} });
            dynamicUpdate({ key: "callComment", value: "" });
            dynamicUpdate({ key: "callBackDate", value: "" });
            dynamicUpdate({ key: "dncType", value: "" });
            dynamicUpdate({ key: "transcription", value: [] });
            dynamicUpdate({ key: "agentAssist", value: [] });
            if (nextState == "preview" && state == "offline") {
              dynamicUpdate({ key: "isPreviewDial", value: false });
            }

            try {
              clearInterval(global.__disposeTimer);
            } catch (error) {}
            if (isCallbackDial) {
              dynamicUpdate({ key: "cbTab", value: "list" });
              dynamicUpdate({ key: "cbListLoading", value: true });
              configProcessor(`notification:list`, {
                page_no: 1,
                limit: 100,
                type: "callBack",
                orderBy: "create_at",
                order: "DESC",
              });
            }
          }
        }}
        ButtonText={`Disposition & Continue ${
          disposeTimer ? "(" + disposeTimer + ")" : ""
        }`}
        isAutoDispose={!!disposeTimer}
        handleAutoDisposeSnooze={this.handleAutoDisposeSnooze}
      />
    );
  }
}

CallTag.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  isConnected: globalStateSelector.getIsConnected(state),
  callInfo: globalStateSelector.getInfo(state),
  custInfo: globalStateSelector.getDynamic(state, { key: "custInfo" }),
  tagsList: globalStateSelector.getDynamic(state, { key: "tagsList" }),
  selectedTag: globalStateSelector.getDynamic(state, { key: "selectedTag" }),
  isPreviewDial: globalStateSelector.getDynamic(state, {
    key: "isPreviewDial",
  }),
  isCallbackDial: globalStateSelector.getDynamic(state, {
    key: "isCallbackDial",
  }),
  isTransfer: globalStateSelector.getDynamic(state, { key: "isTransfer" }),
  callTagList: globalStateSelector.getDynamic(state, { key: "callTagList" }),
  callTagFinalTag: globalStateSelector.getDynamic(state, {
    key: "callTagFinalTag",
  }),
  callComment: globalStateSelector.getDynamic(state, { key: "callComment" }),
  callState: globalStateSelector.getDynamic(state, {
    key: "callHandlingState",
  }),
  callBackDate: globalStateSelector.getDynamic(state, { key: "callBackDate" }),
  dncType: globalStateSelector.getDynamic(state, { key: "dncType" }),
  customerNumber: globalStateSelector.getCallCustomerNumber(state),
  callTeam: globalStateSelector.getDynamic(state, { key: "callTeam" }),
  currentUser: globalStateSelector.getDynamic(state, { key: "currentUser" }),
  cbNotify: globalStateSelector.getDynamic(state, { key: "cbNotify" }),
  disposeTimer: globalStateSelector.getDynamic(state, { key: "disposeTimer" }),
  customerName: globalStateSelector.getCallCustomerName(state),
  userState: globalStateSelector.getState(state),
  teamList: globalStateSelector.getTeamList(state),
});
const dispatchToProps = (dispatch) => ({
  clearSocketConnection: () => {
    // dispatch(messageAction.emitSocketMessage());
  },
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  tagProcess: (type, messageData) => {
    dispatch(messageAction.tagProcess(type, messageData));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  },
  dynamicUpdate: (data) => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  clearAgentAssist: () => dispatch(callAction.clearAgentAssist()),
  clearTranscription: () => dispatch(callAction.clearTranscription()),
  clearSummary: () => dispatch(callAction.clearSummary()),
  clearChecklist: () => dispatch(callAction.clearChecklist()),
});

export default connect(stateToProps, dispatchToProps)(CallTag);



// WEBPACK FOOTER //
// src/dialpad/components/layout/CallTag.js